import { useCallback } from 'react';
import {
  useDeleteBoardPreference,
  usePatchBoardPreference,
} from '../api/hooks';

export type UseBoardPreferenceAdminResult<T extends Record<string, unknown>> = {
  setBoardDefault: (value: T) => Promise<void>;
  resetBoardDefault: () => Promise<void>;
  isMutating: boolean;
};

export const useBoardPreferenceAdmin = <T extends Record<string, unknown>>(
  boardId: number | undefined,
  key: string,
): UseBoardPreferenceAdminResult<T> => {
  const patchMutation = usePatchBoardPreference<T>();
  const deleteMutation = useDeleteBoardPreference<T>();

  const setBoardDefault = useCallback(
    async (value: T) => {
      if (!boardId) return;
      await patchMutation.mutateAsync({ boardId, key, data: value });
    },
    [boardId, key, patchMutation],
  );

  const resetBoardDefault = useCallback(async () => {
    if (!boardId) return;
    await deleteMutation.mutateAsync({ boardId, key });
  }, [boardId, deleteMutation, key]);

  return {
    setBoardDefault,
    resetBoardDefault,
    isMutating: patchMutation.isLoading || deleteMutation.isLoading,
  };
};
